module.exports = __webpack_public_path__ + "assets/img/bp_d_i_3.4bbc6000.jpg";